import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import CheckBox from '../../../../Shared/ReactCheckBox/ReactCheckbox';
import React, { useState, useCallback, useEffect } from 'react';
import OnlySimProcess from './OnlySimProcess';
import DeviceProcess from './DeviceProcess';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { Container, Row } from 'reactstrap';
import Buttons from '../../Constans/Buttons';
import { LEASING_TEXT, isAllowedEsim, steps, PathHistory } from '../../IdfSaleEnums';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';

function SelectProcess(props) {
  const [canContinue, setCanContinue] = useState(false)

  useEffect(() => {
    if (
      (props.processType === 'DEVICE' && isNullOrEmpty(props.idfStore.selectedPhone)) ||
      (props.processType === 'SIM' && props.isShowEsim && props.idfStore.simType == null && props.idfStore.lineType != 2)
    ) {
      setCanContinue(false);
    } else {
      return setCanContinue(true);
    }
  }, [props.processType, props.idfStore.selectedPhone,props.idfStore.simType]);


  return (
    <div className='select-process inner-step'>
      {!props.idfStore.isLeasing ? (
        <>
          {!props.idfStore.deviceUpgradeProcessing && (
            <>
              <Container fluid className='idf-step-header justify-content-center d-flex flex-column align-items-center'>
                <Row className='idf-title-bold justify-content-center d-flex'>בחירת מכשיר</Row>
                <Row className='idf-line justify-content-center d-flex'></Row>
              </Container>
              <Row className='idf-sub-title-bold justify-content-center d-flex'>מה תרצו לעשות?</Row>
              <div className='radio-input-container'>
                <RadioInput
                  checked={props.processType === 'DEVICE'}
                  id={'device'}
                  name={'lineType'}
                  value={'DEVICE'}
                  label={'לרכוש מכשיר'}
                  onRadioChange
                  onChange={(e) => props.setProcessType(e.target.value)}
                />
                <RadioInput
                  checked={props.processType === 'SIM'}
                  id={'onlysim'}
                  name={'lineType'}
                  value={'SIM'}
                  label={'להמשיך בתהליך ללא רכישת מכשיר'}
                  onChange={(e) => props.setProcessType(e.target.value)}
                />
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <Row className='idf-title-bold justify-content-center d-flex'>מסלול ליסינג</Row>
          <Row className='idf-line justify-content-center d-flex'></Row>
          <ul className='leasing-text-container'>
            {LEASING_TEXT.map((row) => (
              <li>{row}</li>
            ))}
          </ul>
        </>
      )}

      {/* <button onClick={}></button> */}
      {(props.processType === 'SIM' && props.idfStore.lineType != 2) && (
        <OnlySimProcess
          isAllowedEsim={() => isAllowedEsim({ store: props.idfStore, esimFlag: props.isShowEsim })}
          simType={props.idfStore.simType}
          setSimType={props.setSimType}
          isShowEsim={props.isShowEsim}
          {...props}></OnlySimProcess>
      )}
      {props.processType === 'DEVICE' && (
        <DeviceProcess
          deviceUpgradeProcessing={props.idfStore.deviceUpgradeProcessing}
          userType={props.idfStore.userDetails.user_type_id}
          contentData={props.contentData}
          setSelectedPhone={props.setSelectedPhone}
          selectedPhone={props.idfStore.selectedPhone}
          isLeasing={props.idfStore.isLeasing}
          setIsLeasing={props.setIsLeasing}
          data={props.data}></DeviceProcess>
      )}
      <div className='idf-sale-buttons-container'>
        {/* <BtnSubmit disabled={disableButton()} isBusiness text='בחרתי, אפשר להתקדם' onclick={() => props.innerStepsNavigation(true, null)} /> */}
        <Buttons
          onClickNavigation={props.onClickNavigation}
          isForm={false}
          setIsSubmit={''}
          canContinue={canContinue}
          btnContinueText={'בחרתי, אפשר להתקדם'}
        />
      </div>
    </div>
  );
}

export default SelectProcess;
